// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__5GgPd","card":"Dashboard_card__fj9QF","flatPickr":"Dashboard_flatPickr__CVNeI"};